import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HomeProjects.css";

import AnimatedShaderBackground from "./ui/AnimatedShaderBackground";

const HomeProjects = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });
  }, []);

  const projects = [
    {
      id: "patrimonio-vivo",
      name: "Patrimonio Vivo",
      logo: "/img/logopv.png",
      description: "Tecnología para preservar recuerdos, estimular la memoria y conectar generaciones.",
      link: "https://patrimoniovivo.sparklingtech.es/",
      gradient: "linear-gradient(135deg, #fba8eaff 0%, #b265ffff 100%)"
    },
    {
      id: "adaia",
      name: "ADAIA",
      logo: "/img/ADAIA_logo.png",
      description: "Inteligencia Artificial emocional para acompañamiento individual y bienestar basado en ciencia.",
      link: "https://adaia.sparklingtech.es/",
      gradient: "linear-gradient(135deg, #fba8eaff 0%, #b265ffff 100%)"
    },
    {
      id: "neuroglint",
      name: "NeuroGlint",
      logo: "/img/Neuroglint_corto.png",
      description: "Neurociencia aplicada para convertir estímulos y comportamiento en datos estratégicos.",
      link: "https://neuroglint.sparklingtech.es/",
      gradient: "linear-gradient(135deg, #fba8eaff 0%, #b265ffff 100%)"
    }
  ];

  return (
    <section className="home-projects-section">
      <div className="home-projects-container">
        <h2 className="home-projects-title" data-aos="fade-up">
          Nuestra tecnología
        </h2>
        <p className="home-projects-subtitle" data-aos="fade-up" data-aos-delay="100">
          Impulsamos el futuro de la salud a través de soluciones disruptivas.
        </p>

        <div className="home-projects-grid">
          {projects.map((project, index) => (
            <a
              key={project.id}
              href={project.link}
              className="home-project-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="home-project-card-content">
                <div className="home-project-logo">
                  <img src={project.logo} alt={project.name} />
                </div>
                <div className="home-project-card-arrow">
                  <span className="arrow-elem">
                    <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
                      <path d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z" />
                    </svg>
                  </span>
                </div>
                <h3 className="home-project-name">{project.name}</h3>
                <p className="home-project-description">{project.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeProjects;
